import { SymbolDefinition } from '../SymbolComponent';

const NAME = 'rectangle';
export interface RectangleSymbol extends SymbolDefinition {
  name: typeof NAME;
}

export const rectangleSymbol: RectangleSymbol = {
  name: NAME,
  lockedAspectRatio: false,
  startWithFixedAspectRatio: false,
  hasStrokeSettings: true,
};
